import { DownArrowIcon, StarIcon } from "@assets/icons"
import useProfile from "@hooks/useProfile"
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material"
import { useEffect } from "react"
import { useSelector } from "react-redux"

const OrbsWayPlans = () => {
  const isMobile = window.innerWidth < 824
  const { getPriceResponse } = useSelector((state) => state.profile)
  const { handleGetPrice } = useProfile()
  useEffect(() => {
    handleGetPrice()
  }, [handleGetPrice])

  const planCodes = {
    OY0240003: "Quarterly",
    OY0240006: "Half yearly",
    OY0240012: "Yearly",
  }
  return (
    <>
      <Accordion
        disabled={!isMobile}
        className="p-4 py-8 md:px-8 md:py-10 !white !rounded-2xl flex flex-col relative md:mx-0 !shadow-none min-h-[88px] before:hidden border border-[#D6EBFF] !bg-[--pure-white]"
        sx={{
          "&.Mui-expanded": {
            gap: "16px",
          },
        }}
        disableGutters
        disableSpacing
        defaultExpanded={!isMobile}
      >
        <AccordionSummary
          expandIcon={
            <DownArrowIcon
              className="h-6 w-6 text-[#292D32] md:hidden"
              disableGutters
              disableSpacing
            />
          }
          className="!p-0 !min-h-6 !m-0 border-none z-[1]"
          sx={{
            ".MuiAccordionSummary-content": {
              margin: 0,
            },
            "&.Mui-disabled": {
              opacity: "1",
            },
          }}
          disableSpacing
          disableGutters
        >
          <div className="flex items-center gap-4 justify-between grow">
            <div className="flex gap-2 items-center">
              <StarIcon
                className="h-6 w-6 text-[var(--text-theme)]"
                strokeWidth="2"
              />
              <h2 className="text-xs text-[--text-light-gray] font-bold tracking-widest">
                ORBSWAY PLANS
              </h2>
            </div>
          </div>
        </AccordionSummary>

        <AccordionDetails
          className="!p-0 !m-0 !text-[var--(--text-light-gray)]"
          disableSpacing
        >
          <div className="flex flex-col gap-4 mt-4">
            {getPriceResponse
              ? Object.entries(planCodes).map(([key, value]) => {
                  return (
                    <div className="flex justify-between grow px-8 py-2 rounded-2xl bg-[--primary-blue-light]">
                      <div className="text-sm text-[--text-light-gray] font-bold">
                        {value}
                      </div>
                      <div className="text-xs text-[--text-light-gray]">
                        INR {getPriceResponse?.price[key]}
                      </div>
                    </div>
                  )
                })
              : null}
          </div>
        </AccordionDetails>
      </Accordion>
    </>
  )
}

export default OrbsWayPlans
